import { connect } from 'react-redux';
import get from 'lodash.get';
import { selectors } from '../../../../root/reading/root';
import fetchFormData from '../../../../api/forms/reading/formsActions';
import DecodingProbeDetails from '../../../../features/probeDetails/reading/do/DecodingProbeDetails';

const mapStateToProps = (state, { result }) => ({
    categoriesOfQuestions: get(selectors.getFormByID(state, result.formUid), 'questions', {}),
});

const mapDispatchToProps = (dispatch, { result }) => ({
    fetchFormData: () => dispatch(fetchFormData(result.measure, result.formUid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DecodingProbeDetails);
